module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      'loader',
      'loader--dots-active',
      {
        'loader--messages': _vm.messages
      }
    ]
  }, [_c('div', {
    staticClass: "loader__items"
  }, [_c('div', {
    staticClass: "message__block",
    style: ([_vm.wrapperStyle])
  }), _vm._v(" "), (_vm.messages) ? _c('module-messages', {
    attrs: {
      "messages": _vm.messages
    },
    on: {
      "messages-height": _vm.getMessageHeight,
      "messages-complete": _vm.onMessagesComplete
    }
  }) : _vm._e(), _vm._v(" "), _c('module-dots')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af84cc14"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ModuleLoader.vue
// module id = 422
// module chunks = 0